import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=645f8aeb&scoped=true&"
import script from "./Costs.vue?vue&type=script&lang=js&"
export * from "./Costs.vue?vue&type=script&lang=js&"
import style0 from "./Costs.vue?vue&type=style&index=0&id=645f8aeb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f8aeb",
  null
  
)

component.options.__file = "Costs.vue"
export default component.exports